import gql from 'graphql-tag';

export default gql`
  query getSubscription($subscription_id: ID!) {
    getSubscription(subscription_id: $subscription_id) {
      id
      created
      current_period_start
      current_period_end
      canceled_at
      ended_at
      status
      paymentIntent
      subscriptionItems {
        id
        plan {
          id
          active
          amount
          nickname
          usage_type
          metadata
        }
      }
    }
  }
`;
